export default {
  setSelections(state, val) {
    state.selections = val.selections;
  },

  setSelectedPolicyType(state, val) {
    state.saleReport.policyType = val.policyType
  }
}



// WEBPACK FOOTER //
// ./src/Dw/store/mutations.js